import React from "react";

import Colors from "../../Constants/Colors";

function HorizontalLine({ className = "", color = Colors.font1, width = '100%' }) {
  const STYLES = {
    margin: "10px 0",
    color,
    width
  };

  return <hr className={`${className}`} style={STYLES} />;
}

export default HorizontalLine;
